import { transformToObject } from '../../utils/error'
import { gnarClient } from '../gnar'
import { LogLevel, sendFelogEvent } from './event'

export enum LogErrorMetrics {
  TouchDeviceDetectionFailed = 'TouchDeviceDetectionFailed',
  UserServiceMethodFailed = 'UserServiceMethodFailed',
  GnarContainerIdFailed = 'GnarContainerIdFailed',
  G4DEditor = 'G4DEditor',
  Llama = 'Llama',
  Drift = 'Drift',
  Qualified = 'Qualified',
  ContentRendererError = 'ContentRendererError',
  FormSubmitError = 'FormSubmitError',
  EncodeUserIdGTMError = 'EncodeUserIdGTMError',
  GTMDataLayerPushError = 'GTMDataLayerPushError',
  UnifiedAuth = 'UnifiedAuth',
  OneTrust = 'OneTrust',
  BoundaryError = 'BoundaryError',
  GOToolError = 'GOToolError',
  GrammarCheckError = 'GrammarCheckError',
  AIDetectorError = 'AIDetectorError',
  PlagiarismCheckerError = 'PlagiarismCheckerError',
  Discount = 'Discount',
  IframeError = 'IframeError',
  Transcend = 'Transcend',
  Ninetailed = 'Ninetailed',
  WebGL = 'WebGL',
}

export async function logError(
  msg: string,
  metricName: LogErrorMetrics,
  extraInfo: { [key: string]: string | object } = {},
  logger = 'Error'
): Promise<void> {
  const extra: { [key: string]: string | object | LogErrorMetrics } = {
    metricName,
    ...extraInfo,
  }
  try {
    extra.containerId = await gnarClient.getContainerId()
  } catch (err) {
    try {
      await sendFelogEvent('Cannot get containerID', LogLevel.Error, logger, {
        metricName: 'cannotGetContainerID',
        error: transformToObject(err as Error),
        ...extraInfo,
      })
    } catch (_) {
      // Ignore this error. Something went wrong with felog event logging
    }
  }

  try {
    await sendFelogEvent(msg, LogLevel.Error, logger, extra)
  } catch (_) {
    // Ignore this error. Something went wrong with felog event logging
  }
}
